var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixTableReservationsV1ReservationLocation from '@wix/ambassador-table-reservations-v1-reservation-location/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var Unit;
(function (Unit) {
    Unit["UNKNOWN"] = "UNKNOWN";
    Unit["MINUTES"] = "MINUTES";
    Unit["HOURS"] = "HOURS";
    Unit["DAYS"] = "DAYS";
})(Unit || (Unit = {}));
/** Type of the field. */
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN"] = "UNKNOWN";
    FieldType["TABLE"] = "TABLE";
    FieldType["START_DATE"] = "START_DATE";
    FieldType["END_DATE"] = "END_DATE";
    FieldType["CREATED_DATE"] = "CREATED_DATE";
    FieldType["UPDATED_DATE"] = "UPDATED_DATE";
    FieldType["PARTY_SIZE"] = "PARTY_SIZE";
    FieldType["FIRST_NAME"] = "FIRST_NAME";
    FieldType["LAST_NAME"] = "LAST_NAME";
    FieldType["EMAIL"] = "EMAIL";
    FieldType["PHONE"] = "PHONE";
    FieldType["ADDITIONAL_INFO"] = "ADDITIONAL_INFO";
    FieldType["TEAM_MESSAGE"] = "TEAM_MESSAGE";
    FieldType["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    FieldType["STATUS"] = "STATUS";
})(FieldType || (FieldType = {}));
export var Set;
(function (Set) {
    Set["PUBLIC"] = "PUBLIC";
    Set["FULL"] = "FULL";
})(Set || (Set = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Mode;
(function (Mode) {
    /** DRY RUN. */
    Mode["UNDEFINED"] = "UNDEFINED";
    Mode["DRY_RUN"] = "DRY_RUN";
    Mode["MIGRATE"] = "MIGRATE";
    Mode["FORCE_MIGRATE"] = "FORCE_MIGRATE";
})(Mode || (Mode = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus || (DeleteStatus = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
/** Determines the reset cycle of the feature usage. */
export var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod || (FeaturePeriod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _configuration = { reservationForm: '_reservationForm' };
const _getReservationLocationRequest = {};
const _getReservationLocationResponse = {
    reservationLocation: '_reservationLocation',
};
const _listReservationLocationsRequest = {};
const _listReservationLocationsResponse = {
    reservationLocations: '_reservationLocation',
};
const _location = { address: 'wix.common.Address' };
const _privacyPolicy = { url: 'wix.common.PageUrlV2' };
const _queryReservationLocationsRequest = {};
const _queryReservationLocationsResponse = {
    reservationLocations: '_reservationLocation',
};
const _reservationForm = {
    termsAndConditions: '_termsAndConditions',
    privacyPolicy: '_privacyPolicy',
};
const _reservationLocation = {
    location: '_location',
    configuration: '_configuration',
};
const _termsAndConditions = { url: 'wix.common.PageUrlV2' };
const _updateReservationLocationRequest = {
    reservationLocation: '_reservationLocation',
};
const _updateReservationLocationResponse = {
    reservationLocation: '_reservationLocation',
};
/**
 * Retrieves a reservation location by ID.
 *
 * The `FULL` fieldset can only be retrieved by users with the `READ RESERVATION LOCATIONS (FULL)` or `MANAGE RESERVATION LOCATIONS` permission scopes.
 * @param reservationLocationId - ID of the ReservationLocation to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField reservationLocationId
 * @param options - An object representing the available options for retrieving a reservation location.
 * @returns The retrieved reservation location.
 */
export function getReservationLocation(reservationLocationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservationLocationId: '$[0]',
            fieldSet: '$[1].fieldSet',
            fieldsets: '$[1].fieldsets',
        };
        const responseTransformation = '$.reservationLocation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getReservationLocationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getReservationLocationResponse,
            depSchemas: {
                _configuration,
                _location,
                _privacyPolicy,
                _reservationForm,
                _reservationLocation,
                _termsAndConditions,
            },
            fqdnTransformation: {
                paths: [...['reservationLocation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationLocationId, options]);
        const reqOpts = ambassadorWixTableReservationsV1ReservationLocation.getReservationLocation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationLocationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a reservation location. Supports partial updates.
 *
 * Each time the reservation location is updated, `revision` increments by 1. The existing revision must be included when updating the reservation location. This ensures you're working with the latest reservation location information, and it prevents unintended overwrites.
 *
 * You cannot use this endpoint to change a reservation location's `location` object. Attempting to do so will cause the server to return an application error.
 * @param _id - Reservation location ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField reservationLocation
 * @requiredField reservationLocation.configuration.onlineReservations.manualApproval
 * @requiredField reservationLocation.revision
 * @param reservationLocation - Reservation location information to update.
 * @adminMethod
 * @returns The updated reservation location.
 */
export function updateReservationLocation(_id, reservationLocation, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservationLocation: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.reservationLocation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateReservationLocationRequest,
            depSchemas: {
                _configuration,
                _location,
                _privacyPolicy,
                _reservationForm,
                _reservationLocation,
                _termsAndConditions,
            },
            fqdnTransformation: {
                paths: [...['reservationLocation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateReservationLocationResponse,
            depSchemas: {
                _configuration,
                _location,
                _privacyPolicy,
                _reservationForm,
                _reservationLocation,
                _termsAndConditions,
            },
            fqdnTransformation: {
                paths: [...['reservationLocation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, reservationLocation, options]);
        const reqOpts = ambassadorWixTableReservationsV1ReservationLocation.updateReservationLocation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'reservationLocation',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of reservation locations.
 *
 *
 * The `queryReservationLocations()` function builds a query to retrieve a list of reservation locations and returns a [`ReservationLocationsQueryBuilder`](#ReservationLocationsQueryBuilder) object.
 *
 * The returned object contains the query definition, which is used to run the query using the [find()](#ReservationLocationsQueryBuilder/find) function.
 *
 * You can refine the query by chaining `ReservationLocationsQueryBuilder` functions onto the query. `ReservationLocationsQueryBuilder` functions enable you to filter, sort, and control the results that `queryReservationLocations()` returns.
 *
 * `queryReservationLocations()` runs with the following `ReservationLocationsQueryBuilder` defaults, which you can override:
 *
 * * [`skip(0)`](#ReservationLocationsQueryBuilder/skip)
 * * [`limit(50)`](#ReservationLocationsQueryBuilder/limit)
 * * [`descending('_createdDate')`](#ReservationLocationsQueryBuilder/descending)
 *
 * The following `ReservationLocationsQueryBuilder` functions are supported for `queryReservationLocations()`. For a full description of the reservation location object, see the object returned for the [`items`](#ReservationLocationsQueryResult/items) property in [`ReservationLocationsQueryResult`](#ReservationLocationsQueryResult).
 * @public
 * @documentationMaturity preview
 * @param options - An object representing the available options for querying reservation locations.
 */
export function queryReservationLocations(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.reservationLocations',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryReservationLocationsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryReservationLocationsResponse,
        depSchemas: {
            _configuration,
            _location,
            _privacyPolicy,
            _reservationForm,
            _reservationLocation,
            _termsAndConditions,
        },
        fqdnTransformation: {
            paths: [...['Array#reservationLocations']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixTableReservationsV1ReservationLocation.queryReservationLocations(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Retrieves a list of up to 100 reservation locations.
 *
 * The `FULL` fieldset can only be retrieved by users with the `READ RESERVATION LOCATIONS (FULL)` or `MANAGE RESERVATION LOCATIONS` permission scopes.
 * @public
 * @documentationMaturity preview
 * @param options - An object representing the available options for listing reservation locations.
 */
export function listReservationLocations(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            paging: '$[0].paging',
            sort: '$[0].sort',
            fieldSet: '$[0].fieldSet',
            fieldsets: '$[0].fieldsets',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listReservationLocationsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listReservationLocationsResponse,
            depSchemas: {
                _configuration,
                _location,
                _privacyPolicy,
                _reservationForm,
                _reservationLocation,
                _termsAndConditions,
            },
            fqdnTransformation: {
                paths: [...['Array#reservationLocations']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixTableReservationsV1ReservationLocation.listReservationLocations(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=table-reservations-v1-reservation-location.universal.js.map